import {
  Slider,
  SliderFilledTrack,
  SliderProps,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import React from "react";

interface VolumeControlV2Props {
  volume: number;
  disabled: boolean;
  setVolume: (volume: number) => void;
}

export const VolumeControlV2: React.FC<VolumeControlV2Props & SliderProps> = ({
  setVolume,
  volume,
  disabled,
  ...sliderProps
}) => {
  const color = "whiteAlpha.300";
  return (
    <Slider
      value={volume * 100}
      onChange={(value) => setVolume(value / 100)}
      max={100}
      isDisabled={disabled}
      cursor={disabled ? "not-allowed" : "pointer"}
      focusThumbOnChange={false}
      sx={{ touchAction: "none" }}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
      {...sliderProps}
    >
      <SliderTrack bg={color} h="8px" w="8px" borderRadius="full">
        {!disabled && <SliderFilledTrack bg="blue.500" h="8px" w="8px" />}
      </SliderTrack>
      {!disabled && <SliderThumb width="12px" height="12px" />}
    </Slider>
  );
};
